
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rocne-predplatne",
      function () {
        return require("private-next-pages/rocne-predplatne.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rocne-predplatne"])
      });
    }
  